import { sortByName } from '../utils/sortOptions';
import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import api from '../services/api';
import toast from 'react-hot-toast';
import { ArrowRightOnRectangleIcon, MagnifyingGlassIcon, ClockIcon } from '@heroicons/react/24/outline';

const ini = (n='') => n.split(' ').map(w=>w[0]).join('').toUpperCase().slice(0,2) || 'S';
const fmtDate = (d) => d ? new Date(d).toLocaleDateString('en-GB', { day:'2-digit', month:'short', year:'numeric' }) : '—';

const REASON_LABEL = { TC:'Transfer Certificate', dropout:'Dropout', other:'Other' };
const REASON_COLOR = { TC:'#3b6ef8', dropout:'#ef4444', other:'#9094a8' };
const REASON_BG    = { TC:'#eef2ff', dropout:'#fef2f2', other:'#f0f2f7' };

const style = `
  @import url('https://fonts.googleapis.com/css2?family=Sora:wght@300;400;500;600;700&family=JetBrains+Mono:wght@400;500&display=swap');
  .sl*{box-sizing:border-box;} .sl{font-family:'Sora',sans-serif;color:#1a1d2e;animation:slFade .4s ease both;}
  @keyframes slFade{from{opacity:0;transform:translateY(10px)}to{opacity:1;transform:translateY(0)}}
  .sl-hdr{display:flex;align-items:flex-start;justify-content:space-between;margin-bottom:1.75rem;flex-wrap:wrap;gap:12px;}
  .sl-title{font-size:1.6rem;font-weight:700;letter-spacing:-.03em;color:#0f1123;}
  .sl-sub{font-size:.78rem;color:#9094a8;margin-top:2px;}
  .sl-toolbar{display:flex;gap:.7rem;flex-wrap:wrap;align-items:center;margin-bottom:1.2rem;}
  .sl-search-wrap{position:relative;flex:1;max-width:280px;}
  .sl-search-wrap svg{position:absolute;left:11px;top:50%;transform:translateY(-50%);width:14px;height:14px;stroke:#9094a8;pointer-events:none;}
  .sl-search{font-family:'Sora',sans-serif;font-size:.8rem;width:100%;padding:8px 12px 8px 32px;border:1.5px solid #e0e4f0;border-radius:10px;background:white;outline:none;}
  .sl-search:focus{border-color:#f97316;}
  .sl-sel{font-family:'Sora',sans-serif;font-size:.78rem;padding:8px 12px;border:1.5px solid #e0e4f0;border-radius:10px;background:white;outline:none;}
  .sl-sel:focus{border-color:#f97316;}
  .panel{background:white;border-radius:16px;border:1px solid #e8ebf4;overflow:hidden;}
  .panel-hdr{display:flex;align-items:center;gap:10px;padding:14px 18px;border-bottom:1px solid #f0f2f8;}
  .panel-icon{width:32px;height:32px;border-radius:9px;background:#fff7ed;color:#f97316;display:flex;align-items:center;justify-content:center;flex-shrink:0;}
  .panel-icon svg{width:16px;height:16px;stroke-width:1.8;}
  .tbl{width:100%;border-collapse:collapse;font-size:.8rem;}
  .tbl thead tr{background:#f8f9fc;border-bottom:1px solid #eaecf4;}
  .tbl th{padding:10px 16px;text-align:center !important;font-size:.65rem;font-weight:700;color:#9094a8;text-transform:uppercase;letter-spacing:.07em;white-space:nowrap;}
  .tbl tbody tr{border-bottom:1px solid #f3f5fb;transition:background .12s;}
  .tbl tbody tr:last-child{border-bottom:none;} .tbl tbody tr:hover{background:#fafbff;}
  .tbl td{ padding:11px 16px;color:#3a3f58;vertical-align:middle; text-align:center !important; }
  .nc{display:flex;align-items:center;gap:10px;}
  .av{width:32px;height:32px;border-radius:9px;background:linear-gradient(135deg,#f97316,#ef4444);display:flex;align-items:center;justify-content:center;font-size:.65rem;font-weight:700;color:white;flex-shrink:0;}
  .nm{font-weight:600;color:#1a1d2e;font-size:.82rem;} .ne{font-size:.68rem;color:#9094a8;margin-top:1px;}
  .tag{display:inline-block;padding:2px 8px;border-radius:99px;font-size:.68rem;font-weight:600;}
  .tag-p{background:#f3f0ff;color:#8b5cf6;} .tag-b{background:#eef2ff;color:#3b6ef8;}
  .mono{font-family:'JetBrains Mono',monospace;font-size:.75rem;color:#6b7194;}
  .reason-tag{display:inline-flex;font-size:.68rem;font-weight:600;padding:3px 9px;border-radius:99px;}
  .empty{text-align:center;padding:52px 20px;color:#b0b5cc;font-size:.82rem;}
  .spin{width:16px;height:16px;border:2px solid #e4e7f0;border-top-color:#f97316;border-radius:50%;animation:sp .7s linear infinite;display:inline-block;}
  @keyframes sp{to{transform:rotate(360deg);}}
  /* Mobile cards */
  .cards{display:none;padding:10px;}
  .card{background:#fafbff;border-radius:12px;border:1px solid #e8ebf4;padding:13px;margin-bottom:8px;}
  .card-top{display:flex;align-items:flex-start;justify-content:space-between;margin-bottom:8px;gap:8px;}
  .card-row{display:flex;justify-content:space-between;align-items:flex-start;font-size:.75rem;padding:4px 0;border-bottom:1px solid #f0f2f8;gap:8px;}
  .card-row:last-of-type{border-bottom:none;}
  .card-lbl{color:#9094a8;font-weight:600;white-space:nowrap;flex-shrink:0;}
  .act-btn{width:30px;height:30px;border-radius:8px;border:1px solid #e8ebf4;background:#f8f9fc;display:inline-flex;align-items:center;justify-content:center;cursor:pointer;margin-left:4px;transition:.13s;}
  .act-btn svg{width:14px;height:14px;stroke-width:1.8;}
  .act-btn.history{color:#8b5cf6;} .act-btn.history:hover{background:#f3f0ff;border-color:#8b5cf6;}
  @media(max-width:768px){.sl-title{font-size:1.2rem;}.tbl-wrap{display:none!important;}.cards{display:block;}.sl-search-wrap{max-width:100%;}}
`;

export default function StudentLeft() {
  const navigate = useNavigate();
  const [students, setStudents] = useState([]);
  const [loading,  setLoading]  = useState(true);
  const [search,   setSearch]   = useState('');
  const [reason,   setReason]   = useState('');
  const [classes,  setClasses]  = useState([]);
  const [classId,  setClassId]  = useState('');

  useEffect(() => { load(); loadClasses(); }, []);

  const load = async () => {
    try {
      setLoading(true);
      const { data } = await api.get('/admin/students/left');
      setStudents(Array.isArray(data) ? data : []);
    } catch { toast.error('Failed to load'); }
    finally   { setLoading(false); }
  };

  const loadClasses = async () => {
    try { const { data } = await api.get('/admin/classes'); setClasses(Array.isArray(data) ? data : []); } catch {}
  };

  const filtered = students.filter(s => {
    if (reason  && s.leftReason !== reason)  return false;
    if (classId && s.class?._id !== classId) return false;
    if (search) {
      const q = search.toLowerCase();
      if (!s.user?.name?.toLowerCase().includes(q) && !s.admissionNo?.toLowerCase().includes(q)) return false;
    }
    return true;
  });

  return (
    <div className="sl"><style>{style}</style>
      <div className="sl-hdr">
        <div>
          <h1 className="sl-title">Left Students</h1>
          <p className="sl-sub">Students who have left via TC, dropout, or other reasons. Historical records are preserved.</p>
        </div>
      </div>

      <div className="sl-toolbar">
        <div className="sl-search-wrap">
          <MagnifyingGlassIcon />
          <input className="sl-search" placeholder="Search by name or admission no…"
            value={search} onChange={e => setSearch(e.target.value)} />
        </div>
        <select className="sl-sel" value={reason} onChange={e => setReason(e.target.value)}>
          <option value="">All Reasons</option>
          <option value="dropout">Dropout</option>
          <option value="other">Other</option>
          <option value="TC">Transfer Certificate</option>
        </select>
        <select className="sl-sel" value={classId} onChange={e => setClassId(e.target.value)}>
          <option value="">All Classes</option>
          {sortByName(classes).map(c => <option key={c._id} value={c._id}>{c.name}</option>)}
        </select>
      </div>

      <div className="panel">
        <div className="panel-hdr">
          <div className="panel-icon"><ArrowRightOnRectangleIcon /></div>
          <div>
            <div style={{fontWeight:600,fontSize:'.88rem'}}>Left Students</div>
            <div style={{fontSize:'.72rem',color:'#9094a8'}}>{loading ? 'Loading…' : `${filtered.length} student${filtered.length !== 1 ? 's' : ''}`}</div>
          </div>
        </div>

        {loading ? (
          <div style={{display:'flex',alignItems:'center',justifyContent:'center',gap:10,padding:'48px 0',color:'#9094a8',fontSize:'.82rem'}}><span className="spin"/>Loading…</div>
        ) : filtered.length === 0 ? (
          <div className="empty">No left students found.</div>
        ) : (
          <>
            <div className="tbl-wrap" style={{overflowX:'auto'}}>
              <table className="tbl">
                <thead><tr><th>Student</th><th>Admission No</th><th>Class</th><th>Section</th><th>Reason</th><th>Left Date</th><th>Note</th><th>Marked By</th><th>History</th></tr></thead>
                <tbody>
                  {filtered.map(s => (
                    <tr key={s._id}>
                      <td><div className="nc"><div className="av">{ini(s.user?.name)}</div><div><div className="nm">{s.user?.name}</div><div className="ne">{s.user?.email}</div></div></div></td>
                      <td><span className="mono">{s.admissionNo}</span></td>
                      <td><span className="tag tag-p">{s.class?.name || '—'}</span></td>
                      <td><span className="tag tag-b">{s.section}</span></td>
                      <td>
                        <span className="reason-tag" style={{background: REASON_BG[s.leftReason]||'#f0f2f7', color: REASON_COLOR[s.leftReason]||'#9094a8'}}>
                          {REASON_LABEL[s.leftReason] || s.leftReason || '—'}
                        </span>
                      </td>
                      <td><span className="mono">{fmtDate(s.leftAt)}</span></td>
                      <td><span style={{fontSize:'.76rem',color:'#6b7194'}}>{s.leftNote || '—'}</span></td>
                      <td><span style={{fontSize:'.76rem',color:'#9094a8'}}>{s.leftBy?.name || '—'}</span></td>
                      <td><button className="act-btn history" title="Full History" onClick={()=>navigate(`/students/${s._id}/history`)}><ClockIcon/></button></td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            {/* Mobile cards */}
            <div className="cards">
              {filtered.map(s => (
                <div key={s._id} className="card">
                  <div className="card-top">
                    <div className="nc"><div className="av">{ini(s.user?.name)}</div><div><div className="nm">{s.user?.name}</div><div className="ne">{s.user?.email}</div></div></div>
                    <span className="reason-tag" style={{background: REASON_BG[s.leftReason]||'#f0f2f7', color: REASON_COLOR[s.leftReason]||'#9094a8'}}>{REASON_LABEL[s.leftReason] || s.leftReason}</span>
                  </div>
                  <div className="card-row"><span className="card-lbl">Admission No</span><span className="mono">{s.admissionNo}</span></div>
                  <div className="card-row"><span className="card-lbl">Class</span><span className="tag tag-p">{s.class?.name || '—'}</span></div>
                  <div className="card-row"><span className="card-lbl">Section</span><span className="tag tag-b">{s.section}</span></div>
                  <div className="card-row"><span className="card-lbl">Left Date</span><span className="mono">{fmtDate(s.leftAt)}</span></div>
                  {s.leftNote && <div className="card-row"><span className="card-lbl">Note</span><span style={{fontSize:'.74rem',color:'#6b7194',textAlign:'right'}}>{s.leftNote}</span></div>}
                  <button className="act-btn history" style={{marginTop:8,width:'100%',justifyContent:'center',gap:6,fontFamily:"'Sora',sans-serif",fontSize:'.74rem',fontWeight:600}} onClick={()=>navigate(`/students/${s._id}/history`)}><ClockIcon/>Full History</button>
                </div>
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}